import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Warehouse from "./Warehouse";
import GridConfig from "./GridConfig";
import { Header } from './Header';
import { Footer } from './Footer';
import WarehouseLocations from "./WarehouseLocations";

export default class Warehouses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'warehouse',
            data: null,
            loading: true,
            configName: 'warehouses_grid',
            moduleName: 'انبارها',
            systemModuleId: 5,
            moduleAccessStatus: 1,
            menuId: 19
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            this.state.moduleAccessStatus = data.status;

            this.refreshData();
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Warehouse Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Warehouse Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "نام انبار", show: true },
                { field: "code", caption: "کد", show: true },
                { field: "address", caption: "آدرس", show: true },
                { field: "phone", caption: "تلفن", show: true },
                { field: "isDefault", caption: "پیش فرض", show: true },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    locations(warehouseId) {
        this.showComponents({ component: <WarehouseLocations WarehouseId={warehouseId} Caller={this} /> });
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'address' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'phone' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'isDefault' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return props.data.isDefault ? <a className="text-success txt-bold">بله</a> : null } });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: "", filter: false, flex: 1, headerName: "عملیات", cellRenderer: (props) => {
                return <div className="item-actions">
                    <a className="item-delete-btn" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                        <i className="mir-trash text-danger"></i>
                    </a>
                    <a className="item-edit-btn" onClick={e => this.onEdit(props.data.id)} title="ویرایش">
                        <i className="mir-pen-edit text-blue-ff"></i>
                    </a>
                    <a className="text-success hand" onClick={e => this.locations(props.data.id)} title="جایگاه ها">
                        جایگاه ها
                    </a>
                </div>
            }
        });
        return t;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner p-0">
                            {this.getToolBar(false, {
                                add: true,
                                print: false,
                                pdf: false,
                                excell: false,
                                remove: false,
                                otherFilters: null,
                                config: false
                            })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}